import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, InlineNotification, Password, TextBox} from '@veneer/core';

import {GlobalTranslationsContext, getCsrfToken} from '@br/idm-components';

import type {FormErrors} from '../../types';

const LoginUsername = ({errors, initialUsername}: {errors: FormErrors; initialUsername: string}): JSX.Element => {
    const {t} = useTranslation(['login']);
    const {veneer: veneerTranslations} = useContext(GlobalTranslationsContext);

    return (
        <form
            method="post"
            className="flex flex-column align-content-center"
        >
            <input
                type="hidden"
                name="csrfmiddlewaretoken"
                value={getCsrfToken()}
            />
            <TextBox
                className="mb-3"
                id="username"
                name="username"
                label={t('login:username', 'User Name')}
                defaultValue={initialUsername}
                error={'username' in errors}
                helperText={(errors.username || []).map(error => error.message).join('\n')}
            />
            <Password
                className="mb-3"
                id="password"
                name="password"
                // eslint-disable-next-line i18next/no-literal-string
                autoComplete="on"
                label={t('login:password', 'Password')}
                error={'password' in errors}
                requirementsPlacement="bottom"
                helperText={(errors.password || []).map(error => error.message).join('\n')}
                i18n={veneerTranslations.password}
            />
            {(errors.__all__ || []).map(({message}) => (
                <InlineNotification
                    role="alert"
                    key={message}
                    hideIcon={false}
                    closeButton={false}
                    title={message}
                    type={'negative'}
                    i18n={veneerTranslations.inlineNotification}
                />
            ))}
            <div>
                <Button type="submit">{t('login:login', 'Sign in')}</Button>
            </div>
        </form>
    );
};

export default LoginUsername;
